<template>
  <div>
    <template v-if="!isLevel2">
      <div v-loading="cptLoading" element-loading-spinner="atom-audit-loader" id="cptCodeList">
        <v-client-table v-if="toggleGrid" key="cptGrid" class="hiaTable" :class="{ truCodeEnabled: true }" ref="cptGrid" id="cptGrid" :data="proReview.proRecordCpts" :columns="columns" :options="options">
          <template slot="h__originalCpt">
            <div>Orig. CPT</div>
            <div class="feeScheduleHeader">
              <div class="feeScheduleHeaderChild">Work RVU</div>
            </div>
          </template>

          <template slot="h__originalMods">
            <div>Mods</div>
            <div class="feeScheduleHeader">
              <div class="feeScheduleHeaderChild">Global Surgery</div>
            </div>
          </template>

          <template slot="h__originalDescCalc">
            <div>Desc</div>
            <div style="display: flex" class="feeScheduleHeader">
              <div class="feeScheduleHeaderChild" style="flex: 1 1">
                Assistant at Surgery
              </div>
              <div class="feeScheduleHeaderChild" style="flex: 1 1; margin-left: 10px;">
                Co-Surgeons
              </div>
            </div>
          </template>

          <template slot="h__recommendedCpt">
            <div>Rec. CPT</div>
            <div class="feeScheduleHeader">
              <div class="feeScheduleHeaderChild">Rec. Work RVU</div>
            </div>
          </template>

          <template slot="h__recommendedMods">
            <div>Mods</div>
            <div class="feeScheduleHeader">
              <div class="feeScheduleHeaderChild">Rec. Global Surgery</div>
            </div>
          </template>

          <template slot="h__recDescCalc">
            <div>Desc</div>
            <div style="display: flex" class="feeScheduleHeader">
              <div class="feeScheduleHeaderChild" style="flex: 1 1">
                Rec. Asst. at Surgery
              </div>
              <div class="feeScheduleHeaderChild" style="flex: 1 1; margin-left: 10px;">
                Rec. Co-Surgeons
              </div>
            </div>
          </template>

          <template slot="lineSequence" slot-scope="props">
            <span class="dragIcon drag-handle" style="margin-top: 3px; float: left">{{ props.row.lineSequence }}</span>
          </template>

          <!-- <template slot="procedureDate" slot-scope="props">
            <el-date-picker :disabled="disabled" size="mini" type="date" id="revDate" v-model="props.row.procedureDate" @input="putProCpt(props.row, 'cptCode')"
              format="MM/dd/yyyy">
            </el-date-picker>
          </template> -->

          <template slot="codeType" slot-scope="props">
            <hia-el-select :disabled="disabled" @input="putProCpt(props.row, $event)" v-model="props.row.codeType" placeholder="Code Type" itemkey="key" label="value" :dropdowns="dropdowns.codeTypes.list" filterable> </hia-el-select>
          </template>

          <template slot="originalCpt" slot-scope="props">
            <div>
              <HiaCodeInput :ref="props.row.cptId + 'origCpt'" style="width: 112px;" :inputId="`originalCpt_${props.index}`" class="noRightBorder borderLeftRadius" v-model="props.row.originalCpt" :disabled="disabled" @ellipsisClick="emitEllipsisClick(props.row.originalCpt)" @focus="emitFocusedCode(props.row.originalCpt)" @change="putProCpt(props.row, 'cptCode', $event)"> </HiaCodeInput>
            </div>
            <div style="margin-top: 1px;" v-html="cptCodeEdits(props.row.edits)"></div>
            <div class="feeScheduleData" title="Original Work RVU" v-html="getPhysicianFeeScheduleData(props.row, 'workRvu', 0)"></div>
          </template>

          <template slot="originalMods" slot-scope="props">
            <div style="margin-top: 3px;">
              <div ref="originalModifier" v-html="cptModifiers(props.row.proRecordModifiers, 'originalModifier')"></div>
            </div>
            <div :title="`Original Global Surgery\n${getGlobalSurgeryTitle(getPhysicianFeeScheduleData(props.row, 'globalSurgery', 0))}`" class="feeScheduleData" v-html="getPhysicianFeeScheduleData(props.row, 'globalSurgery', 0)"></div>
          </template>

          <template slot="originalDescCalc" slot-scope="props">
            <span style="margin-top: 3px;" class="overflow" :id="'OrDesc_' + props.row.cptId" @click="expandDesc(props.row.cptId)">{{ props.row.originalDescCalc }}</span>
            <div style="display: flex;">
              <div style="flex: 1 1;">
                <div :title="`Original Assistant at Surgery\n${getAssistantSurgeryTitle(getPhysicianFeeScheduleData(props.row, 'assistantAtSurgery', 0))}`" class="feeScheduleData" v-html="getPhysicianFeeScheduleData(props.row, 'assistantAtSurgery', 0)"></div>
              </div>
              <div style="flex: 1 1;">
                <div style="flex: 1 1; margin-left: 10px;">
                  <div class="feeScheduleData" :title="`Original Co-Surgeons\n${getCoSurgeonTitle(getPhysicianFeeScheduleData(props.row, 'coSurgeons', 0))}`" v-html="getPhysicianFeeScheduleData(props.row, 'coSurgeons', 0)"></div>
                </div>
              </div>
            </div>
          </template>

          <template slot="recommendedCpt" slot-scope="props">
            <div>
              <HiaCodeInput :ref="props.row.cptId + 'recCpt'" style="width: 112px;" :placeholder="props.row.originalCpt" :inputId="`recommendedCpt_${props.index}`" :class="{ deleteCode: props.row.deleteCode }" v-model="props.row.recommendedCpt" :disabled="props.row.deleteCode || disabled" @ellipsisClick="emitEllipsisClick(props.row.recommendedCpt)" @focus="emitFocusedCode(props.row.recommendedCpt)" @change="putProCpt(props.row, 'cptCode', $event)"> </HiaCodeInput>
            </div>
            <div style="margin-top: 1px;" v-html="cptCodeEdits(props.row.recEdits)"></div>
            <div title="Recommended Work RVU" class="feeScheduleData" v-html="getPhysicianFeeScheduleData(props.row, 'workRvu', 1)"></div>
          </template>

          <template slot="recommendedMods" slot-scope="props">
            <div style="margin-top: 3px;">
              <div style="margin-top: 3px; display: inline-block" ref="recommendedModifier" v-html="recCptModifers(props.row.proRecordModifiers, 'originalModifier', 'recommendedModifier')"></div>
            </div>
            <div :title="`Recommended Global Surgery\n${getGlobalSurgeryTitle(getPhysicianFeeScheduleData(props.row, 'globalSurgery', 1))}`" class="feeScheduleData" v-html="getPhysicianFeeScheduleData(props.row, 'globalSurgery', 1)"></div>
          </template>

          <template slot="recDescCalc" slot-scope="props">
            <div style="margin-top: 3px;" class="overflow" :id="'RecDesc_' + props.row.cptId" @click="expandDesc(props.row.cptId)">{{ !props.row.deleteCode ? props.row.recDescCalc : 'Delete Code' }}</div>
            <div style="display: flex;" class="feeScheduleData">
              <div :title="`Recommended Assistant at Surgery\n${getAssistantSurgeryTitle(getPhysicianFeeScheduleData(props.row, 'assistantAtSurgery', 1))}`" style="flex: 1 1;" v-html="getPhysicianFeeScheduleData(props.row, 'assistantAtSurgery', 1)"></div>
              <div :title="`Recommended Co-Surgeons\n${getCoSurgeonTitle(getPhysicianFeeScheduleData(props.row, 'coSurgeons', 1))}`" style="flex: 1 1; margin-left: 10px;" v-html="getPhysicianFeeScheduleData(props.row, 'coSurgeons', 1)"></div>
            </div>
          </template>

          <template slot="actions" slot-scope="props">
            <div style="margin-top: 5px;">
              <iconCheckBox style="float: left" v-model="props.row.deleteCode" title="Delete Code" icon="mdi mdi-alpha-d" :disabled="disabled" @change="putProCpt(props.row, 'deleteCpt', $event)"> </iconCheckBox>
              <iconCheckBox style="float: left" v-model="props.row.exclude" title="Exclude Changes from Coder Stats" icon="mdi mdi-alpha-e" :disabled="disabled" @change="putProCpt(props.row)"> </iconCheckBox>
              <iconCheckBox style="float: left" v-model="props.row.validated" title="Validated by Reviewer" icon="mdi mdi-alpha-v" :disabled="disabled" @change="putProCpt(props.row)"> </iconCheckBox>
              <i class="mdi mdi-alpha-m" @click="openModModal(props.row)" style="cursor: pointer; float: left; font-size: 20px; color: grey;" title="Edit Modifiers"></i>
            </div>
          </template>

          <template slot="reasonForChange" slot-scope="props">
            <hia-el-select style="width: 82%" :title="disableReasonForChange(props.row) ? 'No change on line' : null" :disabled="disableReasonForChange(props.row) || disabled" @input="putProCpt(props.row, $event)" v-model="props.row.reasonForChange" placeholder="Reason for Change" itemkey="key" label="value" :dropdowns="dropdowns.proReasonsForChangeCpt.list" clearable filterable> </hia-el-select>
            <i v-if="!disabled" style="float: right; cursor: pointer; margin-top: -20px;" title="Delete CPT Row" class="el-icon-close delete-button" @click="deleteCpt(props.row)"></i>
          </template>
        </v-client-table>

        <v-client-table v-if="toggleGrid" key="cptGridAddRow" class="hiaTable" ref="cptGridAddRow" id="cptGridAddRow" :data="addRow" :columns="addRowColumns" :options="addOptions">
          <template slot="lineSequence">
            <div>&nbsp;</div>
          </template>

          <template slot="codeType" slot-scope="props">
            <hia-el-select :disabled="disabled" @input="setAddRow(props.row)" v-model="props.row.codeType" placeholder="Code Type" itemkey="key" label="value" :dropdowns="dropdowns.codeTypes.list" filterable> </hia-el-select>
          </template>

          <template slot="originalCpt" slot-scope="props">
            <input style="width: 100px; text-transform: uppercase; font-size: 12px" v-mask="'NNNNNNN'" :disabled="disabled" :readonly="loading" id="originalCpt" maxlength="5" minlength="3" v-model="props.row.originalCpt" v-on:keyup.enter="addCptRow(props.row)" />
          </template>

          <template slot="originalMods" slot-scope="props">
            <el-select :disabled="disabled" class="addMultiModifiers" @input="setMultiMods(props.row, 'originalModifiers', 'Recommended', 'recommendedModifiers', $event)" v-model="props.row.originalModifiers" filterable multiple clearable placeholder="Multiple Mods">
              <el-option v-for="item in dropdowns.modifiers.list" :key="item.key" :label="item.key" :value="item.key" :title="item.value"> </el-option>
            </el-select>
          </template>

          <template slot="originalDescCalc">
            <div>&nbsp;</div>
          </template>

          <template slot="recommendedCpt" slot-scope="props">
            <input style="width: 100px; text-transform: uppercase; font-size: 12px" v-mask="'NNNNNNN'" :disabled="disabled" :readonly="loading" id="recommendedCpt" maxlength="7" minlength="3" v-model="props.row.recommendedCpt" v-on:keyup.enter="addCptRow(props.row)" />
          </template>

          <template slot="recommendedMods" slot-scope="props">
            <el-select :disabled="disabled" class="addMultiModifiers" @input="setMultiMods(props.row, 'recommendedModifiers', 'Original', 'originalModifiers', $event)" v-model="props.row.recommendedModifiers" filterable multiple clearable placeholder="Multiple Mods">
              <el-option v-for="item in dropdowns.modifiers.list" :key="item.key" :label="item.key" :value="item.key" :title="item.value"> </el-option>
            </el-select>
          </template>

          <template slot="reasonForChange" slot-scope="props">
            <el-popover ref="addPopover" style="word-break: normal;" placement="bottom" title="" width="300" trigger="manual" popper-class="popover" :content="addPopoverContent" v-model="showAddPopover" @after-enter="handleHidePopOver('addPopover')">
              <el-button :disabled="disabled" round icon="el-icon-plus" slot="reference" style="float: right;" type="primary" size="mini" @click="addCptRow(props.row)">Add </el-button>
            </el-popover>
          </template>
        </v-client-table>
      </div>
    </template>

    <!-- <template v-if="isLevel2">
      <div v-loading="loading" element-loading-spinner="atom-audit-loader">
        <v-client-table v-if="toggleGrid" key="cptGridLevel2" class="hiaTable" ref="cptGridLevel2" id="cptGridLevel2" :data="proReview.proRecordCpts" :columns="level2Columns"
          :options="level2Options">

          <template slot="lineSequence" slot-scope="props">
            <span class="dragIcon drag-handle" style="margin-top: 3px; float: left">{{props.row.lineSequence}}</span>
          </template>

          <template slot="codeType" slot-scope="props">
            <hia-el-select :disabled="disabled" @input="putProCpt(props.row, $event)" v-model="props.row.codeType" placeholder="Code Type" itemkey="key" label="value"
              :dropdowns="dropdowns.codeTypes.list" filterable>
            </hia-el-select>
          </template>

          <template slot="originalCpt" slot-scope="props">
            <div>
              <HiaCodeInput style="width: 77px;" :inputId="`originalCpt_${props.index}`" class="noRightBorder borderLeftRadius" v-model="props.row.originalCpt"
                :disabled="disabled" @ellipsisClick="emitEllipsisClick(props.row.originalCpt)" @focus="emitFocusedCode(props.row.originalCpt)"
                @change="putProCpt(props.row, 'cptCode')">
              </HiaCodeInput>
            </div>
            <span style="float: left; margin-top: 1px;" v-html="cptCodeEdits(props.row.edits)"></span>
          </template>

          <template slot="originalDescCalc" slot-scope="props">
            <div style="margin-top: 3px;">{{props.row.originalDescCalc}}</div>
          </template>

          <template slot="recommendedCpt" slot-scope="props">
            <div>
              <HiaCodeInput style="width: 77px;" :placeholder="props.row.originalCpt" :inputId="`recommendedCpt_${props.index}`" :class="{deleteCode: props.row.deleteCode}"
                v-model="props.row.recommendedCpt" :disabled="props.row.deleteCode" @ellipsisClick="emitEllipsisClick(props.row.recommendedCpt)"
                @focus="emitFocusedCode(props.row.recommendedCpt)" @change="putProCpt(props.row, 'cptCode')">
              </HiaCodeInput>
            </div>
            <span style="float: left" v-html="cptCodeEdits(props.row.recEdits)"></span>
          </template>

          <template slot="recDescCalc" slot-scope="props">
            <div style="margin-top: 3px;">{{!props.row.deleteCode ? props.row.recDescCalc : 'Delete Code'}}</div>
          </template>

          <template slot="actions" slot-scope="props">
            <div style="margin-top: 5px;">
              <iconCheckBox style="float: left" v-model="props.row.deleteCode" title="Delete Code" icon="mdi mdi-alpha-d" :disabled="disabled"
                @input="putProCpt(props.row, 'deleteCpt')">
              </iconCheckBox>
              <iconCheckBox style="float: left" v-model="props.row.exclude" title="Exclude Changes from Coder Stats" icon="mdi mdi-alpha-e" :disabled="disabled"
                @input="putProCpt(props.row)">
              </iconCheckBox>
              <iconCheckBox style="float: left" v-model="props.row.validated" title="Validated by Reviewer" icon="mdi mdi-alpha-v" :disabled="disabled"
                @input="putProCpt(props.row)">
              </iconCheckBox>
            </div>
          </template>

          <template slot="reasonForChange" slot-scope="props">
            <hia-el-select style="width: 100px;" :disabled="disabled" @input="putProCpt(props.row, $event)" v-model="props.row.reasonForChange" placeholder="Reason for Change"
              :filterable="true" itemkey="key" label="value" :dropdowns="dropdowns.proReasonsForChange.list">
            </hia-el-select>
          </template>

          <template slot="level2Cpt" slot-scope="props">
            <div>
              <HiaCodeInput style="width: 77px;" :placeholder="props.row.recommendedCpt ? props.row.recommendedCpt : props.row.originalCpt"
                :inputId="`level2Cpt_${props.index}`" :class="{deleteCode: props.row.level2DeleteCode || props.row.deleteCode}" v-model="props.row.level2Cpt"
                :disabled="props.row.level2DeleteCode" @ellipsisClick="emitEllipsisClick(props.row.level2Cpt)" @focus="emitFocusedCode(props.row.level2Cpt)"
                @change="putProCpt(props.row, 'cptCode')">
              </HiaCodeInput>
            </div>
            <span style="float: left" v-html="cptCodeEdits(props.row.level2Edits)"></span>
          </template>

          <template slot="level2DescCalc" slot-scope="props">
            <div style="margin-top: 3px;">{{!props.row.level2DeleteCode ? props.row.level2DescCalc : 'Delete Code'}}</div>
          </template>

          <template slot="level2Actions" slot-scope="props">
            <div style="margin-top: 5px;">
              <iconCheckBox style="float: left" v-model="props.row.level2DeleteCode" title="Level 2 Delete Code" icon="mdi mdi-alpha-d" :disabled="disabled"
                @input="putProCpt(props.row, 'deleteCptLevel2')">
              </iconCheckBox>
              <iconCheckBox style="float: left" v-model="props.row.level2Exclude" title="Exclude Level 2 Changes from Coder Stats" icon="mdi mdi-alpha-e" :disabled="disabled"
                @input="putProCpt(props.row)">
              </iconCheckBox>
              <iconCheckBox style="float: left" v-model="props.row.level2Validated" title="Validated by Level 2 Reviewer" icon="mdi mdi-alpha-v" :disabled="disabled"
                @input="putProCpt(props.row)">
              </iconCheckBox>
            </div>
          </template>

          <template slot="level2ReasonForChange" slot-scope="props">
            <hia-el-select style="width: 82%" :disabled="disabled" @input="putProCpt(props.row, $event)" v-model="props.row.level2ReasonForChange"
              placeholder="Reason for Change" itemkey="key" label="value" :dropdowns="dropdowns.proReasonsForChange.list" clearable filterable>
            </hia-el-select>
            <i style="float: right; cursor: pointer; margin-top: -20px;" title="Delete CPT Row" class="el-icon-close delete-button" @click="deleteCpt(props.row)"></i>

          </template>

        </v-client-table>

        <v-client-table v-if="toggleGrid" key="cptGridLevel2AddRow" class="hiaTable" ref="cptGridLevel2AddRow" id="cptGridLevel2AddRow" :data="addRow"
          :columns="level2AddRowColumns" :options="level2Options">

          <template slot="codeType" slot-scope="props">
            <hia-el-select :disabled="disabled" @input="setAddRow(props.row)" v-model="props.row.codeType" placeholder="Code Type" itemkey="key" label="value"
              :dropdowns="dropdowns.codeTypes.list" clearable filterable>
            </hia-el-select>
          </template>

          <template slot="originalCpt" slot-scope="props">
            <input style="width: 65px; text-transform: uppercase" v-mask="'NNNNNNN'" :disabled="disabled" :readonly="loading" id="originalCpt" maxlength="7" minlength="3"
              v-model="props.row.originalCpt" @keyup.enter="addCptRow(props.row)">
          </template>

          <template slot="originalDescCalc">
          </template>

          <template slot="recommendedCpt" slot-scope="props">
            <input style="width: 65px; text-transform: uppercase" v-mask="'NNNNNNN'" :disabled="disabled" :readonly="loading" id="recommendedCpt" maxlength="7" minlength="3"
              v-model="props.row.recommendedCpt" @keyup.enter="addCptRow(props.row)">

          </template>

          <template slot="actions">
            <div>&nbsp;</div>
          </template>

          <template slot="reasonForChange">
            <hia-el-select style="width: 100px; visibility: hidden;"></hia-el-select>
          </template>

          <template slot="level2Cpt" slot-scope="props">
            <input style="width: 65px; text-transform: uppercase" v-mask="'NNNNNNN'" :disabled="disabled" :readonly="loading" id="level2Cpt" maxlength="7" minlength="3"
              v-model="props.row.level2Cpt" @keyup.enter="addCptRow(props.row)">
          </template>

          <template slot="level2ReasonForChange" slot-scope="props">
            <el-popover ref="addPopoverLevel2" style="word-break: normal;" placement="bottom" title="" width="300" trigger="manual" popper-class="popover"
              :content="addPopoverContent" v-model="showAddPopover" @after-enter="handleHidePopOver('addPopoverLevel2')">
              <el-button slot="reference" style="float: right;" type="primary" size="mini" @click="addCptRow(props.row)">Add</el-button>
            </el-popover>
          </template>
        </v-client-table>
      </div>
    </template> -->

    <div class="dialogs">
      <addMultipleCodes :disabled="disabled" :defaultCodeType="proReview.project.defaultCodeType" :codeTypeRequired="true" :show="showAddMultipleCodes" :type="'CPT'" :review="proReview" @close="handleCloseAddMultipleCodes" @postAddMultipleCodes="postAddMultipleCodes"> </addMultipleCodes>
    </div>

    <el-dialog
      v-if="modModalCpt !== null"
      class="modDialog"
      :visible="showModModal"
      :title="`Edit Modifiers for CPT Line ${modModalCpt.lineSequence}`"
      width="80%"
      :before-close="
        () => {
          showModModal = false
        }
      "
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form size="mini" label-position="left" label-width="140px">
        <el-row style="margin-bottom: 20px;">
          <el-col :span="12">
            <el-form-item label="Original Cpt">
              <div style="width: 100%;">
                <el-input style="width: 112px; display: inline-block;" inputId="originalCptMod" v-model="modModalCpt.originalCpt" disabled> </el-input>
                <span style=" margin-left: 5px; margin-top: 3px; display: inline-block" ref="originalModifier" v-html="cptModifiers(modModalCpt.proRecordModifiers, 'originalModifier')"> </span>
              </div>
              <div>
                <div style="margin: 3px 5px 0px 0px; display: inline-block"><span style="float: left; margin-top: 1px;" v-html="cptCodeEdits(modModalCpt.edits)"></span></div>
                <div style="margin-top: 3px; display: inline-block" class="overflow" :id="'OrDesc_Mod_' + modModalCpt.cptId" @click="expandDesc(modModalCpt.cptId, true)">{{ modModalCpt.originalDescCalc }}</div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Recommended Cpt">
              <div style="width: 100%;">
                <el-input style="width: 112px; display: inline-block;" :placeholder="modModalCpt.originalCpt" inputId="recCptMod" v-model="modModalCpt.recommendedCpt" disabled :class="{ deleteCode: modModalCpt.level2DeleteCode || modModalCpt.deleteCode }"> </el-input>
                <span style="margin-left: 5px; margin-top: 3px; display: inline-block" ref="originalModifier" v-html="recCptModifers(modModalCpt.proRecordModifiers, 'originalModifier', 'recommendedModifier')"> </span>
              </div>
              <div style="margin: 3px 5px 0px 0px; display: inline-block"><span style="float: left; margin-top: 1px;" v-html="cptCodeEdits(modModalCpt.recEdits)"></span></div>
              <div style="margin-top: 3px; display: inline-block" class="overflow" :id="'RecDesc_Mod_' + modModalCpt.cptId" @click="expandDesc(modModalCpt.cptId, true)">{{ !modModalCpt.deleteCode ? modModalCpt.recDescCalc : 'Delete Code' }}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-row>
        <el-col :span="12">
          <h4 class="headerWithBorder">Original Modifiers</h4>
        </el-col>
        <el-col :span="12">
          <h4 class="headerWithBorder">Recommended Modifiers</h4>
        </el-col>
      </el-row>
      <proReviewModifiers :cpt="modModalCpt"> </proReviewModifiers>

      <span slot="footer">
        <el-button @click="showModModal = false" size="mini" type="text" plain round>Close</el-button>
      </span>
    </el-dialog>

    <el-popover ref="savePopover" style="word-break: normal;" placement="bottom" title="" width="300" trigger="manual" popper-class="popover" :content="savePopoverContent" @after-enter="handleHidePopOver('savePopover')"> </el-popover>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import iconCheckBox from '@/components/controls/iconCheckBox'
  import HiaCodeInput from '@/components/controls/HiaCodeInput'
  import proReviewModifiers from './proReviewModifiers'
  import Sortable from 'sortablejs'
  import addMultipleCodes from '@/components/controls/addMultipleCodes'
  import HiaAuthorization from '@/mixins/hiaAuthorization'

  export default {
    name: 'proReviewCpts',
    props: ['showAddMultipleCodes'],
    mixins: [HiaAuthorization],
    data: function() {
      return {
        activeName: null,
        toggleGrid: true,
        loading: false,
        // disabled: false,
        theSortable: null,
        addPopoverContent: '',
        savePopoverContent: '',
        showAddPopover: false,
        showModModal: false,
        modModalCpt: null,
        addRow: [{ codeType: null, originalCpt: '', recommendedCpt: '', originalModifiers: [], recommendedModifiers: [] }],
        addRowColumns: ['lineSequence', 'codeType', 'originalCpt', 'originalMods', 'originalDescCalc', 'recommendedCpt', 'recommendedMods', 'recDescCalc', 'actions', 'reasonForChange'],
        columns: ['lineSequence', 'codeType', 'originalCpt', 'originalMods', 'originalDescCalc', 'recommendedCpt', 'recommendedMods', 'recDescCalc', 'actions', 'reasonForChange'],
        level2Columns: ['lineSequence', 'codeType', 'originalCpt', 'originalDescCalc', 'recommendedCpt', 'recDescCalc', 'actions', 'reasonForChange', 'level2Cpt', 'level2DescCalc', 'level2Actions', 'level2ReasonForChange'],
        level2AddRowColumns: ['lineSequence', 'codeType', 'originalCpt', 'originalDescCalc', 'recommendedCpt', 'recDescCalc', 'actions', 'reasonForChange', 'level2Cpt', 'level2DescCalc', 'level2Actions', 'level2ReasonForChange'],
        options: {
          filterable: false,
          filterByColumn: false,
          resizableColumns: false,
          queue: [],
          networkFunction: null,
          showChildRowToggler: false,
          perPage: 100,
          columnsClasses: {
            lineSequence: 'lineSequenceCol',
            procedureDate: 'procedureDateCol',
            codeType: 'codeTypeCol',
            originalCpt: 'oneHundredPx',
            originalMods: 'seventyFivePx',
            originalDescCalc: 'twentyPercent',
            recommendedCpt: 'oneHundredPx',
            recDescCalc: 'twentyPercent',
            recommendedMods: 'seventyFivePx',
            actions: 'actionsCol',
            reasonForChange: 'reasonForChangeCol',
            add: 'thirtyPx',
            delete: 'thirtyPx'
          },
          headings: {
            lineSequence: '#',
            procedureDate: 'Procedure Date',
            codeType: 'Type',
            grouperFlags: 'GF',
            recommendedGrouperFlags: 'GF',
            originalCpt: 'Orig. CPT',
            originalMods: 'Mods',
            recommendedCpt: 'Rec. CPT',
            recommendedMods: 'Mods',
            originalDescCalc: 'Desc.',
            recDescCalc: 'Desc.',
            recommendedEdits: 'Edits',
            reasonForChange: 'Reason For Change',
            delete: '',
            add: ''
          }
        },
        level2Options: {
          filterable: false,
          filterByColumn: false,
          resizableColumns: false,
          perPage: 100,
          columnsClasses: {
            lineSequence: 'lineSequenceCol',
            originalMods: 'seventyFivePx',
            originalCpt: 'seventyFivePx',
            originalDescCalc: 'twentyPercent descOverflow',
            recommendedCpt: 'seventyFivePx',
            recommendedMods: 'seventyFivePx',
            recDescCalc: 'twentyPercent descOverflow',
            actions: 'actionsCol',
            reasonForChange: 'reasonForChangeCol',
            level2Cpt: 'seventyFivePx',
            level2DescCalc: 'twentyPercent descOverflow',
            level2Actions: 'actionsCol',
            level2ReasonForChange: 'reasonForChangeCol',
            add: 'thirtyPx',
            delete: 'thirtyPx'
          },
          headings: {
            lineSequence: '#',
            grouperFlags: 'GF',
            recommendedGrouperFlags: 'GF',
            originalCpt: 'Orig. Px',
            recommendedCpt: 'Rec. Px',
            originalDescCalc: 'Desc.',
            recDescCalc: 'Desc.',
            recommendedEdits: 'Edits',
            reasonForChange: 'Reason For Change',
            level2Cpt: 'Lvl. 2 Px',
            level2DescCalc: 'Desc',
            level2Actions: 'Actions',
            level2ReasonForChange: 'Reason For Change',
            delete: '',
            add: ''
          }
        },
        addOptions: {
          filterable: false,
          filterByColumn: false,
          resizableColumns: false,
          queue: [],
          networkFunction: null,
          showChildRowToggler: false,
          perPage: 100,
          columnsClasses: {
            lineSequence: 'lineSequenceCol',
            procedureDate: 'procedureDateCol',
            codeType: 'codeTypeCol',
            originalCpt: 'oneHundredPx',
            originalMods: 'codeTypeCol',
            originalDescCalc: 'tenPercent',
            recommendedCpt: 'oneHundredPx',
            recDescCalc: 'tenPercent',
            recommendedMods: 'codeTypeCol',
            actions: 'actionsCol',
            reasonForChange: 'reasonForChangeCol',
            add: 'thirtyPx',
            delete: 'thirtyPx'
          },
          headings: {
            lineSequence: '#',
            procedureDate: 'Procedure Date',
            codeType: 'Type',
            grouperFlags: 'GF',
            recommendedGrouperFlags: 'GF',
            originalCpt: 'Orig. CPT',
            originalMods: 'Mods',
            recommendedCpt: 'Rec. CPT',
            recommendedMods: 'Mods',
            originalDescCalc: 'Desc.',
            recDescCalc: 'Desc.',
            recommendedEdits: 'Edits',
            reasonForChange: 'Reason For Change',
            delete: '',
            add: ''
          }
        }
      }
    },
    components: {
      iconCheckBox,
      HiaCodeInput,
      addMultipleCodes,
      proReviewModifiers
    },
    methods: {
      ...mapActions('proReviews/', ['PUT_PRO_CPT', 'DELETE_PRO_CPT', 'POST_PRO_CPT', 'PUT_PRO_CPTS_FOR_RESEQUENCE']),
      ...mapMutations('proReviews/', ['SET_PRO_CPT_ROW', 'PUSH_CPT_ROW', 'SET_PRO_CPTS']),
      setAddRow(row) {
        this.$set(this.addRow, 0, row)
      },
      openModModal(row) {
        this.modModalCpt = this.proReview.proRecordCpts.find(x => x.cptId === row.cptId)
        this.showModModal = true
      },
      async putProCpt(row, changedField, e) {
        if (!row.recommendedCpt && !row.originalCpt) {
          this.savePopoverContent = 'Either Original CPT or Recommended CPT must be populated. To delete the entire row, use the X button on the right side.'
          this.openSavePopover(e)
          const backupRow = this.proReview.proRecordCpts.find(x => x.cptId === row.cptId)
          this.SET_PRO_CPT_ROW(backupRow)
          this.$refs[row.cptId + 'recCpt'].$forceUpdate()
          this.$refs[row.cptId + 'origCpt'].$forceUpdate()
          return
        }

        if (!row.originalCpt && changedField === 'deleteCpt') {
          this.savePopoverContent = 'The Delete Code recommendation cannot be used if there is no Original CPT.'
          this.openSavePopover(e)
          const backupRow = this.proReview.proRecordCpts.find(x => x.cptId === row.cptId)
          this.SET_PRO_CPT_ROW(backupRow)
          return
        }

        if (row.reasonForChange && !row.recommendedCpt && !row.deleteCode) {
          try {
            await this.$confirm('This will clear the Reason for Change. Continue?', 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
            row.reasonForChange = null
          } catch (e) {
            const backupRow = this.proReview.proRecordCpts.find(x => x.cptId === row.cptId)
            this.SET_PRO_CPT_ROW(backupRow)
            this.$refs[row.cptId + 'recCpt'].$forceUpdate()
            return
          }
        }

        if (changedField === 'deleteCpt' && row.recommendedCpt && row.deleteCode) {
          try {
            await this.$confirm(`This will clear the Recommended CPT ${row.recommendedCpt}. Continue?`, 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
            row.recommendedCpt = null
          } catch (e) {
            row.deleteCode = false
            this.SET_PRO_CPT_ROW(row)
            return
          }
        }

        if (changedField === 'deleteCptLevel2' && row.level2Cpt && row.level2DeleteCode) {
          try {
            await this.$confirm(`This will clear the Level 2 Recommended CPT ${row.level2Cpt}. Continue?`, 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
            row.level2Cpt = null
          } catch (e) {
            row.level2DeleteCode = false
            this.SET_PRO_CPT_ROW(row)
            return
          }
        }

        this.SET_PRO_CPT_ROW(row)
        const payload = { cptRow: row, changedField: changedField }

        this.loading = true
        try {
          await this.PUT_PRO_CPT(payload)
          this.loading = false
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
          this.$message({
            message: 'CPT Code Updated Successfully',
            type: 'success'
          })
        } catch (e) {
          this.loading = false
          this.$message({
            message: 'CPT Code Update Error',
            type: 'error'
          })
        }
      },
      async addCptRow(row) {
        if (!this.isLevel2 && !row.codeType && !row.originalCpt && !row.recommendedCpt) {
          this.addPopoverContent = 'Code Type and either Original CPT or Recommended CPT must be populated to add row.'
          this.showAddPopover = true
          return
        }

        if (!this.isLevel2 && !row.originalCpt && !row.recommendedCpt) {
          this.addPopoverContent = 'Either Original CPT or Recommended CPT must be populated to add row.'
          this.showAddPopover = true
          return
        }

        if (this.isLevel2 && !row.codeType && !row.originalCpt && !row.recommendedCpt && !row.level2Cpt) {
          this.addPopoverContent = 'Code Type and either Original CPT, Recommended CPT or Level 2 CPT must be populated to add row.'
          this.showAddPopover = true
          return
        }

        if (this.isLevel2 && !row.originalCpt && !row.recommendedCpt && !row.level2Cpt) {
          this.addPopoverContent = 'Either Original CPT, Recommended CPT or Level 2 CPT must be populated to add row.'
          this.showAddPopover = true
          return
        }

        if (!row.codeType) {
          this.addPopoverContent = 'Code Type must be populated to add row.'
          this.showAddPopover = true
          return
        }

        row.cptId = 0
        row.proRecordId = this.proReview.proRecordId
        row.newPrimary = false
        row.level2NewPrimary = false
        row.originalCpt = row.originalCpt
          ? row.originalCpt
              .toUpperCase()
              .replace('.', '')
              .trim()
          : null
        row.recommendedCpt = row.recommendedCpt
          ? row.recommendedCpt
              .toUpperCase()
              .replace('.', '')
              .trim()
          : null

        // handle multi modifiers
        let version = null
        let modifiers = []
        if (row.originalModifiers.length) {
          version = 'originalModifier'
          modifiers = row.originalModifiers
        }
        if (row.recommendedModifiers.length) {
          version = 'recommendedModifier'
          modifiers = row.recommendedModifiers
        }
        if (version) {
          row.proRecordModifiers = this.buildModifiers(modifiers, version, row.codeType)
        }

        this.loading = true
        try {
          await this.POST_PRO_CPT([row])
          this.$set(this.addRow, 0, { codeType: row.codeType, originalCpt: '', recommendedCpt: '', originalModifiers: [], recommendedModifiers: [] })
          this.loading = false
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
          this.$message({
            message: 'CPT Code Added Successful',
            type: 'success'
          })
        } catch (e) {
          this.loading = false
          this.$message({
            message: 'CPT Code Added Error',
            type: 'error'
          })
        }
      },
      async deleteCpt(row) {
        this.loading = true
        try {
          await this.DELETE_PRO_CPT(row)
          this.loading = false
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
          this.$message({
            message: 'CPT Code Deleted Successful',
            type: 'success'
          })
        } catch (e) {
          this.loading = false
          this.$message({
            message: 'CPT Code Delete Error',
            type: 'error'
          })
        }
      },
      disableReasonForChange(row) {
        if (!row.recommendedCpt && !row.deleteCode) {
          return true
        }
        return false
      },
      openSavePopover(e) {
        if (!e) {
          return
        }

        const popper = this.$refs.savePopover

        popper.doDestroy()
        popper.doClose()

        this.$nextTick(() => {
          this.popperClickTarget = e.target
          popper.doDestroy()
          popper.referenceElm = this.popperClickTarget
          this.isOpen = true
          popper.doShow()
        })
      },
      handleHidePopOver(ref) {
        const popper = this.$refs[ref]
        const handler = e => {
          if (e.target !== popper.$el) {
            popper.doDestroy()
            popper.doClose()
          }
          document.removeEventListener('click', handler, false)
        }
        document.addEventListener('click', handler, false)
      },
      emitEllipsisClick(code) {
        this.emitFocusedCode(code)
        this.$emit('ellipsisClick', code)
      },
      emitFocusedCode(focusedCode) {
        if (focusedCode && focusedCode !== 'DEL') {
          const truCodeQueryObject = {
            code: focusedCode,
            type: 'CPTAPC'
          }
          this.$emit('onCodeFocus', truCodeQueryObject)
        }
      },
      cptCodeEdits(edits) {
        if (edits.length) {
          let pxDesc = ''
          for (const i in edits) {
            pxDesc += edits[i].description.replace(/<[^>]*>/g, '') + ' \n'
          }
          return '<div style="background: url(/static/trucode/css/img/icons/warning.png); width: 16px; height: 16px; margin-top: 2px"  title="' + pxDesc.trim() + '"></div>'
        }
      },
      getPhysicianFeeScheduleData(cpt, field, level) {
        let data = null
        switch (level) {
          case 0:
            data = cpt.originalCpt ? this.proReview.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level) : null
            break
          case 1:
            data = cpt.recommendedCpt ? this.proReview.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level) : null
            break
          case 2:
            data = cpt.level2Cpt ? this.proReview.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level) : null
            break
        }
        return data ? data[field] : '&nbsp;'
      },
      getGlobalSurgeryTitle(val) {
        const map = {
          '000': '000 - Endoscopic or minor procedure with related preoperative and postoperative relative values on the day of the procedure only included in the fee schedule payment amount; evaluation and management services on the day of the procedure generally not payable.',
          '010': '010 - Minor procedure with preoperative relative values on the day of the procedure and postoperative relative values during a 10 day postoperative period included in the fee schedule amount; evaluation and management services on the day of the procedure and during the 10-day postoperative period generally not payable.',
          '090': '090 - Major surgery with a 1-day preoperative period and 90-day postoperative period included in the fee schedule amount.',
          MMM: 'MMM - Maternity codes; usual global period does not apply.',
          XXX: 'XXX - The global concept does not apply to the code.',
          YYY: 'YYY - The carrier is to determine whether the global concept applies and establishes postoperative period, if appropriate, at time of pricing.',
          ZZZ: 'ZZZ - The code is related to another service and is always included in the global period of the other service.'
        }
        return map[val]
      },
      getCoSurgeonTitle(val) {
        const map = {
          0: '0 - Co-surgeons not permitted for this procedure.',
          1: '1 - Co-surgeons could be paid. Supporting documentation is required to establish medical necessity of 2 surgeons for the procedure.',
          2: '2 - Co-surgeons permitted. No documentation is required if 2 specialty requirements are met.',
          9: '9 - Concept does not apply.'
        }
        return map[val]
      },
      getAssistantSurgeryTitle(val) {
        const map = {
          0: '0 - Payment restriction for assistants at surgery applies to this procedure unless supporting documentation is submitted to establish medical necessity.',
          1: '1 - Statutory payment restriction for assistants at surgery applies to this procedure. Assistants at surgery may not be paid.',
          2: '2 - Payment restriction for assistants at surgery does not apply to this procedure. Assistants at surgery may be paid.',
          9: '9 - Concept does not apply.'
        }
        return map[val]
      },
      async handleDragStop(e) {
        const temp = this.proReview.proRecordCpts[e.oldIndex]
        this.proReview.proRecordCpts.splice(e.oldIndex, 1)
        this.proReview.proRecordCpts.splice(e.newIndex, 0, temp)
        this.updateLineSequence(this.proReview.proRecordCpts)
        this.SET_PRO_CPTS(this.proReview.proRecordCpts)

        // force the grid to re-initialize by destroying and recreating it
        // and then reattaching the sortable
        this.toggleGrid = false
        this.theSortable.destroy()
        this.$nextTick(() => {
          this.toggleGrid = true
          this.$nextTick(() => {
            this.attachSortable()
          })
        })

        this.loading = true
        try {
          await this.PUT_PRO_CPTS_FOR_RESEQUENCE(this.proReview.proRecordCpts)
          this.loading = false
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
        } catch (e) {
          this.loading = true
        }
      },
      updateLineSequence(array) {
        array.map((o, i) => {
          o.lineSequence = i + 1
          return o
        })
      },
      codeType(codeType) {
        if (codeType !== null) {
          let desc = ''
          for (const i in this.dropdowns.codeTypes.list) {
            if (codeType === this.dropdowns.codeTypes.list[i].key) {
              desc = this.dropdowns.codeTypes.list[i].value
              break
            }
          }
          return desc
        }
      },
      cptModifiers(modifiers, version) {
        // remove blank mods
        modifiers = modifiers.filter(function(n) {
          if (n[version] !== undefined && n[version] !== null) {
            return true
          }
          return false
        })
        if (modifiers !== null) {
          const modLength = modifiers.length
          let modifer = ''
          let comma = ''
          if (modLength) {
            const cptId = modifiers[0].cptid
            for (let i = 0; i < modLength; i++) {
              if (modifiers[i][version] !== null && modifiers[i][version].trim().length > 1) {
                comma = modLength > 1 && i + 1 !== modLength ? ',' : ''
                modifer += '<span id="' + version + '_' + i + '" cptId="' + cptId + '" title="' + this.modDescription(modifiers[i][version]) + '">' + modifiers[i][version] + '</span>' + comma
              }
            }
          }
          // modifer += '&nbsp;'
          return modifer
        }
        return null
      },
      recCptModifers(row, originalModifier, recommendedModifier) {
        if (row.length) {
          let modifiers = []
          row.forEach((v, i) => {
            const row = v
            row.displayMod = v[recommendedModifier] || v[originalModifier]
            modifiers.push(row)
          })
          modifiers = modifiers.filter(function(n) {
            if (n.displayMod !== undefined && n.displayMod !== null) {
              return true
            }
            return false
          })
          if (modifiers !== null) {
            const modLength = modifiers.length
            let modifer = ''
            let comma = ''
            if (modLength) {
              for (let i = 0; i < modLength; i++) {
                if (modifiers[i].displayMod !== null && modifiers[i].displayMod.trim().length > 1) {
                  comma = modLength > 1 && i + 1 !== modLength ? ',' : ''
                  modifer += `<span id="recommendedModifier_${i}" ${modifiers[i].deleteCode ? 'class="strikethrough"' : null} title="${this.modDescription(modifiers[i].displayMod, modifiers[i].deleteCode)}">${modifiers[i].displayMod}</span>${comma}`
                }
              }
            }
            // modifer += '&nbsp;'
            return modifer
          }
        }
        return null
      },
      modDescription(modifier, deleteCode = false) {
        if (deleteCode) {
          return 'Delete Modifier'
        }

        if (modifier !== null && modifier.length) {
          let desc = ''
          for (const i in this.dropdowns.modifiers.list) {
            if (modifier === this.dropdowns.modifiers.list[i].key) {
              desc = this.dropdowns.modifiers.list[i].value
                .split('|')[1]
                .trim()
                .toLowerCase()
              break
            }
          }
          return desc
        }
      },
      attachSortable() {
        const gridElementName = this.isLevel2 ? 'cptGridLevel2' : 'cptGrid'
        const gridDiv = document.getElementById(gridElementName)
        if (gridDiv) {
          const tbody = gridDiv.getElementsByTagName('tbody')
          this.theSortable = Sortable.create(tbody[0], {
            animation: 200,
            draggable: 'tr.VueTables__row',
            handle: '.drag-handle',
            onEnd: e => {
              this.handleDragStop(e)
            }
          })
        }
      },
      handleCloseAddMultipleCodes() {
        this.$emit('handleCloseAddMultipleCodes', false)
      },
      async postAddMultipleCodes(data) {
        if (data.codes) {
          // populate new codes
          const newCodes = []
          let startLineSequence = this.proReview.proRecordCpts.length + 1
          data.codes.forEach((v, i) => {
            const newCode = {
              proRecordId: this.proReview.proRecordId,
              lineSequence: startLineSequence,
              add: true,
              originalCpt: data.isRecommended ? null : v.trim(),
              validated: false,
              exclude: false,
              recommendedCpt: data.isRecommended ? v.trim() : null,
              reasonForChange: '',
              level2Cpt: null,
              procedureDate: null,
              level2ReasonForChange: '',
              codeType: data.codeType
            }
            newCodes.push(newCode)
            startLineSequence++
          })
          data.codes = newCodes
          data.changedField = 'addMultipleCodes'

          this.loading = true
          try {
            await this.POST_PRO_CPT(data.codes)
            this.$message({
              message: 'Multiple Codes Added Successfully',
              type: 'success'
            })
          } catch (e) {
            this.$message({
              message: 'Multiple Codes Added Error',
              type: 'error'
            })
          }
          this.loading = false
        }
      },
      expandDesc(cptId, isMod = false) {
        // const targetId = $event.currentTarget.id
        // console.log(targetId)
        const orTargetId = isMod ? 'OrDesc_Mod_' + cptId : 'OrDesc_' + cptId
        const recTargetId = isMod ? 'RecDesc_Mod_' + cptId : 'RecDesc_' + cptId

        const orEl = document.getElementById(orTargetId)
        const recEl = document.getElementById(recTargetId)
        orEl.classList.toggle('overflow')
        recEl.classList.toggle('overflow')
      },
      async setMultiMods(row, version, otherLabel, otherVersion, event) {
        // handle clear logic for original vs recommended
        if (row[otherVersion] && row[otherVersion].length) {
          try {
            await this.$confirm(`This will clear the ${otherLabel} Modifier ${row[otherVersion]}. Continue?`, 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
            row[otherVersion] = []
            this.setAddRow(row)
          } catch (e) {
            row[version] = []
            this.setAddRow(row)
          }
        } else {
          this.setAddRow(row)
        }
      },
      buildModifiers(modifiers, version, codeType) {
        // populate new mods
        const newMods = []
        let startLineSequence = 1
        modifiers.forEach((v, i) => {
          const newMod = {
            lineSequence: startLineSequence,
            [version]: v ? v.trim() : null,
            codeType: codeType
          }
          newMods.push(newMod)
          startLineSequence++
        })

        return newMods
      }
    },
    mounted: function() {
      this.$nextTick(() => {
        this.attachSortable()
      })
    },
    watch: {
      isLevel2(val) {
        this.$nextTick(() => {
          if (this.theSortable) {
            this.attachSortable()
          }
        })
      },
      'proReview.project.defaultCodeType': function(val) {
        if (this.proReview.project) {
          this.addRow = [{ codeType: this.proReview.project.defaultCodeType, originalCpt: '', recommendedCpt: '', originalModifiers: [], recommendedModifiers: [] }]
        }
      }
    },
    computed: {
      ...mapState('proReviews/', ['proReview', 'cptLoading']),
      ...mapState('dropdowns/', ['dropdowns']),
      ...mapState('user/', ['user']),
      disabled() {
        return !!this.readOnly() || this.proReview.reviewStatusId !== 2
      },
      isLevel2: function() {
        return this.proReview.reviewLevel > 1
      }
    }
  }
</script>

<style scoped>
  >>> .strikethrough {
    text-decoration: line-through;
  }

  .dragIcon {
    cursor: move;
    margin: 1px 0px 0px 1px;
    padding: 0px 0px 0px 0px;
    float: left;
    height: 20px;
    color: #1f2d3d;
  }

  .drag-handle {
    cursor: move;
    display: block;
    float: left;
  }

  .modButton {
    padding: 3px 7px;
  }

  >>> .feeScheduleHeader {
    color: #005695;
    border-top: 1px solid rgb(204, 204, 204);
    margin-top: 2px;
    padding-top: 2px;
    font-weight: normal;
    font-size: 11px;
  }

  >>> .feeScheduleData {
    border-top: 1px solid rgb(204, 204, 204);
    padding-top: 5px;
    font-size: 11px;
    position: absolute;
    bottom: 0px;
    margin: 10px 0px 10px 0px;
    width: 100%;
    color: #005695;
  }

  >>> .lineSequenceCol {
    width: 15px !important;
  }

  >>> .procedureDateCol {
    width: 130px;
  }

  >>> .codeTypeCol {
    width: 130px;
  }

  >>> .actionsCol {
    max-width: 90px;
    min-width: 90px;
  }

  >>> .reasonForChangeCol {
    min-width: 140px;
    max-width: 180px;
  }

  >>> .deleteCol {
    max-width: 30px;
  }

  >>> .addCol {
    min-width: 150px;
  }

  >>> .thirtyPx {
    min-width: 20px;
  }

  >>> .fiftyPx {
    width: 50px;
  }

  >>> .seventyFivePx {
    width: 75px;
  }

  >>> .oneHundredPx {
    width: 100px;
  }

  >>> .twentyPercent {
    width: 17%;
  }

  >>> .tenPercent {
    width: 13.5%;
  }

  >>> .descOverflow {
    word-break: break-word;
  }

  .hiaTable .el-icon-close {
    border: 1px solid transparent;
  }

  .hiaTable tr:nth-child(even) .el-icon-close {
    border: 1px solid #606266;
    border-radius: 100%;
  }

  >>> #cptGrid.truCodeEnabled td {
    position: relative;
    padding-bottom: 32px;
  }

  >>> #cptGridAddRow thead,
  >>> #cptGridLevel2AddRow thead {
    visibility: hidden;
  }

  >>> #cptGridAddRow table,
  >>> #cptGridLevel2AddRow table {
    margin-top: -1px;
  }

  >>> #cptGridAddRow tbody > tr {
    height: 40px;
    border-top: 1px solid #ebeef5;
    background-color: #fff !important;
  }

  >>> #cptGridAddRow th,
  >>> #cptGridLevel2AddRow th {
    line-height: 0px;
    padding: 0px 5px 0px 5px;
  }

  >>> #cptGrid tr,
  >>> #cptGridLevel2 tr {
    vertical-align: top;
  }

  >>> #cptGrid ::placeholder,
  >>> #cptGridLevel2 ::placeholder {
    opacity: 0.8;
  }

  >>> .VuePagination__count {
    display: none;
  }

  >>> .VueTables__child-row:hover {
    background-color: #fff;
  }

  /* #cptCodeList>>>.el-collapse-item {
    height: 20px;
  }

  #cptCodeList>>>.el-collapse-item .is-active {
    height: 100%;
  } */

  #cptCodeList >>> .el-collapse-item__header {
    height: 20px !important;
    line-height: 20px !important;
  }

  /* #cptCodeList>>>.el-collapse-item__header {
    height: 20px;
    line-height: 20px;
    padding-left: 15px;
    background-color: #fff;
    color: #48576a;
    cursor: pointer;
    border-bottom: 1px solid #dfe6ec;
    font-size: 13px;
  }

  #cptCodeList li:nth-child(odd)>>>.el-collapse-item__header {
    height: 20px;
    line-height: 20px;
    padding-left: 15px;
    background-color: rgba(109, 207, 246, 0.02);
    color: #48576a;
    cursor: pointer;
    border-bottom: 1px solid #dfe6ec;
    font-size: 13px;
  }

  #cptCodeList>>>.el-collapse-item__header .el-collapse-item__arrow {
    line-height: 20px !important;
  }

  #cptCodeList>>>.el-collapse-item__header>i {
    font-size: 11px !important;
    cursor: zoom-in;
  } */
  .overflow {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-height: 48px;
    text-overflow: ellipsis;
    cursor: zoom-in;
  }

  /* .nooverflow {
    overflow: visible;
  } */

  >>> .addMultiModifiers > .el-select__tags {
    overflow: hidden;
  }
</style>
